var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm._tag,{tag:"component",staticClass:"mdc-ripple-surface vuterial-ripple",attrs:{"to":_vm.to},on:{"click":_vm.click}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }